import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  padding: 50px 15px 15px;
  display: grid;
  justify-items: center;
  gap: 15px;
`;

export const Text = styled(Typography.Body)`
  text-align: center;
`;
